// import React from "react";
// import Slider from "react-slick";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const videos = [
//   {
//     url: "https://www.youtube.com/embed/Q5VjdM7KkfM?si=Yj8k9JMFDjQqJkS1",
//     description:
//       'Shayan Khan, an actor and film producer of the film "Money Back Guarantee," enthusiastically shared his remarkable experience with Mean3’s Celebrity Management and Digital Marketing services, as Mean3 played a significant role in the success of the film, ensuring its reach and impact were maximized.',
//   },
//   {
//     url: "https://www.youtube.com/embed/izPGB4dhqIM?si=KSz8Y7C2A4wmgKNM",
//     description:
//       "Faisal Qureshi, Director of the film Money Back Guarantee shares his incredible experience. Mean3 had the privilege to provide Digital marketing and Celebrity Management services resulting in extensive exposure and engagement across various platforms.",
//   },
//   {
//     url: "https://www.youtube.com/embed/Kv8gAovgL7Q?si=0-Y2qJ5waIcv5b1b",
//     description:
//       "Syed Shafaat Ali, known for stand-up comedy, starred in the film Money Back Guarantee. As he shares his experience with us, we are proud to announce that Mean3 handled his Digital Marketing and Celebrity Management Services maximizing the film's reach and impact on the audience all over social media.",
//   },
//   {
//     url: "https://www.youtube.com/embed/Pq4Yvu2LGuI?si=-YXhBhoSrv4moYUZ",
//     description:
//       "Kiran Malik a Pakistani model and film actress mesmerized the audience with her captivating performance in the film Money Back Guarantee expressed Mean3 ‘s quality of service and professionalism provided through Digital Marketing and Celebrity Management services.",
//   },
// ];

// // Custom Arrows
// const PrevArrow = ({ onClick }) => (
//   <FaChevronLeft
//     className="absolute left-0 md:left-[-40px] top-1/2 transform -translate-y-1/2 cursor-pointer text-red-600 hover:text-gray-900"
//     style={{ fontSize: "30px" }}
//     onClick={onClick}
//   />
// );

// const NextArrow = ({ onClick }) => (
//   <FaChevronRight
//     className="absolute right-0 md:right-[-40px] top-1/2 transform -translate-y-1/2 cursor-pointer text-red-600 hover:text-gray-900"
//     style={{ fontSize: "30px" }}
//     onClick={onClick}
//   />
// );

// const Section2 = () => {
//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     prevArrow: <PrevArrow />,
//     nextArrow: <NextArrow />,
//   };

//   return (
//     <section className="mx-auto py-12">
//       <div className="flex flex-col  lg:flex-row items-center justify-center  gap-4">
//         {/* Left Side - Stays on the left for large screens */}
//         <div className="bg-gray-50 w-[95%] md:w-[95%] lg:w-2/5 min-h-[400px] md:min-h-[650px] shadow-2xl rounded-r-2xl xl:rounded-r-2xl xl:rounded-l-none p-8 text-center flex flex-col justify-evenly self-start xl:self-auto">
//           <div className="flex flex-col gap-2 sm:gap-5">
//             <h3 className="text-xl sm:text-2xl xl:text-3xl 2xl:text-4xl font-bold text-gray-700 uppercase">
//               Result We Achieved
//             </h3>
//             <span className="w-[40%] h-[5px] self-center inline-block  bg-red-600"></span>
//           </div>
//           <h2 className="text-[80px] sm:text-[100px] md:text-[150px] font-bold text-red-600 mt-4">
//             180+
//           </h2>
//           <div className="flex flex-col gap-8">
//             <p className="text-2xl sm:text-2xl xl:text-3xl 2xl:text-4xl tracking-[4px] font-bold text-gray-700">Million Views</p>
//             <ul className="space-y-1 text-black font-medium text-xl sm:text-2xl">
//               <li>Facebook</li>
//               <li>Instagram</li>
//               <li>TikTok</li>
//               <li>YouTube</li>
//             </ul>
//           </div>
//         </div>

//         {/* Right Side - Stays on the right for large screens */}
//         <div className="bg-gray-50 w-[95%] md:w-[95%] lg:w-3/5 min-h-[400px] md:min-h-[650px] flex flex-col justify-center shadow-2xl rounded-l-2xl xl:rounded-l-2xl xl:rounded-r-none p-8 xl:mr-0 self-end xl:self-auto">
//           <h3 className="text-3xl font-semibold text-gray-700 uppercase text-center">
//             Compliments We Got
//           </h3>
//           <div className="mt-6 w-full md:w-[80%] m-auto">
//             <Slider {...settings}>
//               {videos.map((video, index) => (
//                 <div key={index} className="text-center">
//                   <iframe
//                     className="w-full md:h-80 lg:h-96"
//                     src={video.url}
//                     title={`YouTube video ${index + 1}`}
//                     frameBorder="0"
//                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                     allowFullScreen
//                   ></iframe>
//                   <p className="mt-4 text-black text-sm">{video.description}</p>
//                 </div>
//               ))}
//             </Slider>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Section2;


import React from "react";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const videos = [
  {
    url: "https://www.youtube.com/embed/Q5VjdM7KkfM?si=Yj8k9JMFDjQqJkS1",
    description:
      'Shayan Khan, an actor and film producer of the film "Money Back Guarantee," enthusiastically shared his remarkable experience with Mean3’s Celebrity Management and Digital Marketing services, as Mean3 played a significant role in the success of the film, ensuring its reach and impact were maximized.',
  },
  {
    url: "https://www.youtube.com/embed/izPGB4dhqIM?si=KSz8Y7C2A4wmgKNM",
    description:
      "Faisal Qureshi, Director of the film Money Back Guarantee shares his incredible experience. Mean3 had the privilege to provide Digital marketing and Celebrity Management services resulting in extensive exposure and engagement across various platforms.",
  },
  {
    url: "https://www.youtube.com/embed/Kv8gAovgL7Q?si=0-Y2qJ5waIcv5b1b",
    description:
      "Syed Shafaat Ali, known for stand-up comedy, starred in the film Money Back Guarantee. As he shares his experience with us, we are proud to announce that Mean3 handled his Digital Marketing and Celebrity Management Services maximizing the film's reach and impact on the audience all over social media.",
  },
  {
    url: "https://www.youtube.com/embed/Pq4Yvu2LGuI?si=-YXhBhoSrv4moYUZ",
    description:
      "Kiran Malik a Pakistani model and film actress mesmerized the audience with her captivating performance in the film Money Back Guarantee expressed Mean3 ‘s quality of service and professionalism provided through Digital Marketing and Celebrity Management services.",
  },
];

// Custom Arrows with updated responsive positions
const PrevArrow = ({ onClick }) => (
  <FaChevronLeft
    className="absolute left-[-30px] md:left-[-40px] top-[35%] md:top-1/2 transform -translate-y-1/2 cursor-pointer text-red-600 hover:text-gray-900"
    style={{ fontSize: "30px" }}
    onClick={onClick}
  />
);

const NextArrow = ({ onClick }) => (
  <FaChevronRight
    className="absolute right-[-30px] md:right-[-40px] top-[35%] md:top-1/2 transform -translate-y-1/2 cursor-pointer text-red-600 hover:text-gray-900"
    style={{ fontSize: "30px" }}
    onClick={onClick}
  />
);

const Section2 = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
    <section className="mx-auto py-12">
      <div className="flex flex-col lg:flex-row items-center justify-center gap-4">
        {/* Left Side - Stays on the left for large screens */}
        <div className="bg-gray-50 w-[95%] md:w-[95%] lg:w-2/5 min-h-[400px] md:min-h-[650px] shadow-2xl rounded-r-2xl xl:rounded-r-2xl xl:rounded-l-none p-8 text-center flex flex-col justify-evenly self-start xl:self-auto">
          <div className="flex flex-col gap-2 sm:gap-5">
            <h3 className="text-xl sm:text-2xl xl:text-3xl 2xl:text-4xl font-bold text-gray-700 uppercase">
              Result We Achieved
            </h3>
            <span className="w-[40%] h-[5px] self-center inline-block bg-red-600"></span>
          </div>
          <h2 className="text-[80px] sm:text-[100px] md:text-[150px] font-bold text-red-600 mt-4">
            180+
          </h2>
          <div className="flex flex-col gap-8">
            <p className="text-2xl sm:text-2xl xl:text-3xl 2xl:text-4xl tracking-[4px] font-bold text-gray-700">
              Million Views
            </p>
            <ul className="space-y-1 text-black font-medium text-xl sm:text-2xl">
              <li>Facebook</li>
              <li>Instagram</li>
              <li>TikTok</li>
              <li>YouTube</li>
            </ul>
          </div>
        </div>

        {/* Right Side - Stays on the right for large screens */}
        <div className="bg-gray-50 w-[95%] md:w-[95%] lg:w-3/5 min-h-[400px] md:min-h-[650px] flex flex-col justify-center shadow-2xl rounded-l-2xl xl:rounded-l-2xl xl:rounded-r-none p-8 xl:mr-0 self-end xl:self-auto">
          <h3 className="text-3xl font-semibold text-gray-700 uppercase text-center">
            Compliments We Got
          </h3>
          <div className="mt-6 w-full md:w-[80%] m-auto">
            <Slider {...settings}>
              {videos.map((video, index) => (
                <div key={index} className="text-center">
                  <iframe
                    className="w-full md:h-80 lg:h-96"
                    src={video.url}
                    title={`YouTube video ${index + 1}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                  <p className="mt-4 text-black text-sm">{video.description}</p>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section2;
